import { ta } from "date-fns/locale";
import { put, takeLatest, all, call } from "redux-saga/effects";
import {
  requestAccountList,
  requestCreateAccount,
  requestUpdateAccount,
  requestAccountDropDownList,
  requestGetByIdAccount,
  requestLocationAccountList,
  requestGenerateClientId,
  requestGenerateDumpId,
  requestUpdateAccountProfileList,
  requestUpdateAccountProfile,
  requestCreateAccountDetails,
  requestEditUpdateAccountProfile,
  requestUpdateSDWaiveOff,
  requestUpdateSDDue,
  requestclientAccountIdAgreementList,
  fetchAgreementDataForAccount,
  requestCreateProposalAccountList,
  requestGetByIdProposalGenerate,
  requestGetByIdProposalOtView,
  requestCreateProposalProfile,
  requestAccountBookingList,
  requestBookingByAccountList,
  requestSyncFailedMember
} from "../../../services/account";
import {
  fetchAccountListFailure,
  fetchAccountListRequest,
  fetchAccountListSuccess,
  fetchAccountCompanyListRequest,
  fetchAccountCompanyListSuccess,
  fetchAccountCompanyListFailure,
  createAccountRequest,
  createAccountSuccess,
  createAccountFailure,
  updateAccountRequest,
  updateAccountSuccess,
  updateAccountFaliure,
  fetchAccountDropDownListRequest,
  fetchAccountDropDownListSuccess,
  fetchAccountDropDownListFailure,
  accountByIdRequest,
  accountByIdSuccess,
  accountByIdFailure,
  fetchLocationAccountListRequest,
  fetchLocationAccountListSuccess,
  fetchLocationAccountListFailure,
  generateClientIdRequest,
  generateClientDmRequest,
  generateClientDmFailure,
  generateClientDmSuccess,
  generateClientIdSuccess,
  generateClientIdFailure,
  fetchAccountProfileListRequest,
  fetchAccountProfileListSuccess,
  fetchAccountProfileListFailure,
  CreateAccountDetailsRequest,
  CreateAccountDetailsSuccess,
  CreateAccountDetailsFaliure,
  UpdateAccountProfileRequest,
  UpdateAccountProfileSuccess,
  UpdateAccountProfileFaliure,
  editUpdateAccountProfileRequest,
  editUpdateAccountProfileSuccess,
  editUpdateAccountProfileFaliure,
  updateSDWaiveOffRequest,
  updateSDWaiveOffSuccess,
  updateSDWaiveOffFaliure,
  updateSDDueRequest,
  updateSDDueSuccess,
  updateSDDueFaliure,
  fetchClientAccountIdAgreementListRequest,
  fetchClientAccountIdAgreementListSuccess,
  fetchClientAccountIdAgreementListFaliure,
  fetchAgreementDataForAccountRequest,
  fetchAgreementDataForAccountSuccess,
  fetchAgreementDataForAccountFailure,
  fetchClientAccountProposalListRequest,
  fetchClientAccountProposalListSuccess,
  fetchClientAccountProposalListFailure,
  fetchProposalClientByIdRequest,
  fetchProposalClientByIdSuccess,
  fetchProposalClientByIdFailure,
  createProposalAccountSuccess,
  createProposalAccountFailure,
  createProposalAccountRequest,
  fetchProposalClientByIdOtViewRequest,
  fetchProposalClientByIdOtViewSuccess,
  fetchProposalClientByIdOtViewFailure,
  fetchAccountBookingListRequest,
  fetchAccountBookingListSuccess,
  fetchAccountBookingListFailure,
  fetchBookingByAccountListRequest,
  fetchBookingByAccountListSuccess,
  fetchBookingByAccountListFaliure,
  syncFailedMemberRequest,
  syncFailedMemberSuccess,
  syncFailedMemberFaliure
} from "../../reducers/account";

export function* watchAccountSaga() {
  yield takeLatest(fetchAccountListRequest, fetchAccountList);
  yield takeLatest(fetchAccountCompanyListRequest, fetchAccountCompanyList);
  yield takeLatest(createAccountRequest, createAccount);
  yield takeLatest(updateAccountRequest, updateAccount);
  yield takeLatest(fetchAccountDropDownListRequest, fetchAccountDropDownList);
  yield takeLatest(accountByIdRequest, fetchAccountById);
  yield takeLatest(fetchLocationAccountListRequest, fetchLocationAccountList);
  yield takeLatest(generateClientIdRequest, generateClientIdAccount);
  yield takeLatest( generateClientDmRequest, generateClientDmAccount);


  yield takeLatest(fetchAccountProfileListRequest, fetchAccountProfileList);
  yield takeLatest(UpdateAccountProfileRequest, updateAccountProfile);
  yield takeLatest(CreateAccountDetailsRequest, createAccountDetails);
  yield takeLatest(editUpdateAccountProfileRequest, editAccountProfile);
  yield takeLatest(updateSDWaiveOffRequest, updateSDWaiveOff);
  yield takeLatest(updateSDDueRequest, updateSDDue);
  yield takeLatest(
    fetchClientAccountIdAgreementListRequest,
    fetchClientAccountIdAgreementList
  );
  yield takeLatest(fetchAgreementDataForAccountRequest, fetchAccountAgreementData);
  yield takeLatest(fetchClientAccountProposalListRequest,fetchClientAccountProposalList)
  yield takeLatest(fetchProposalClientByIdRequest,fetchClientByIdGenerateProposal)
  yield takeLatest(createProposalAccountRequest,createProposalAccount)
  yield takeLatest(fetchProposalClientByIdOtViewRequest,fetchClientByIdOtViewProposal)
  yield takeLatest(fetchAccountBookingListRequest,fetchAccountBookingData)
  yield takeLatest(fetchBookingByAccountListRequest,fetchBookingByAccountData)
  yield takeLatest(syncFailedMemberRequest,syncFailedMemberData)
}

/**
 *
 * @param {*} param0
 */
function* fetchAccountList({ payload }) {
  try {
    const response = yield requestAccountList(payload);
    yield put(fetchAccountListSuccess(response));
  } catch (error) {
    yield put(fetchAccountListFailure("Failed to get account list"));
  }
}

function* fetchAccountCompanyList({ payload }) {
  try {
    const response = yield requestAccountList(payload);
    yield put(fetchAccountCompanyListSuccess(response));
  } catch (error) {
    yield put(fetchAccountCompanyListFailure("Failed to get account list"));
  }
}

function* createAccount({ payload }) {
  try {
    //service add
    const response = yield requestCreateAccount(payload);
    yield put(createAccountSuccess(response.data));
  } catch (error) {
    yield put(createAccountFailure("Failed to create Account"));
  }
}

function* updateAccount({ payload }) {
  try {
    const response = yield requestUpdateAccount(payload);
    yield put(updateAccountSuccess(response.data));
  } catch (error) {
    yield put(updateAccountFaliure("Failed to get update Account"));
  }
}

function* fetchAccountDropDownList({ payload }) {
  try {
    const response = yield requestAccountDropDownList(payload);
    yield put(fetchAccountDropDownListSuccess(response.data));
  } catch (error) {
    yield put(fetchAccountDropDownListFailure("Failed to getList of Account"));
  }
}
function* fetchAccountById({ payload }) {
  try {
    const response = yield requestGetByIdAccount(payload);
    yield put(accountByIdSuccess(response));
  } catch (error) {
    yield put(accountByIdFailure("Failed to get account Detail"));
  }
}

function* fetchLocationAccountList({ payload }) {
  try {
    if (localStorage.getItem("accountlist") && !payload?.override) {
      yield put(
        fetchLocationAccountListSuccess(
          JSON.parse(localStorage.getItem("accountlist"))
        )
      );
    } else {
      const response = yield requestLocationAccountList();
      localStorage.setItem("accountlist", JSON.stringify(response?.data));
      yield put(fetchLocationAccountListSuccess(response.data));
    }
  } catch (e) {
    yield put(fetchLocationAccountListFailure("failed to get list"));
  }
}

function* generateClientIdAccount({ payload }) {
  try {
    const response = yield requestGenerateClientId(payload);
    yield put(generateClientIdSuccess(response));
  } catch (error) {
    yield put(generateClientIdFailure("Failed to Generate Client Account ID"));
  }
}
function* generateClientDmAccount({ payload }) {
  try {
    const response = yield requestGenerateDumpId(payload);
    yield put(generateClientDmSuccess(response));
  } catch (error) {
    yield put(generateClientDmFailure("Failed to Generate Client Account ID"));
  }
}
function* fetchAccountProfileList({ payload }) {
  try {
    const response = yield requestUpdateAccountProfileList(payload);
    yield put(fetchAccountProfileListSuccess(response.data));
  } catch (error) {
    yield put(
      fetchAccountProfileListFailure("Failed to get List of Account Profile")
    );
  }
}
function* updateAccountProfile({ payload }) {
  try {
    const response = yield requestUpdateAccountProfile(payload);
    yield put(UpdateAccountProfileSuccess(response.data));
  } catch (error) {
    yield put(
      UpdateAccountProfileFaliure("Failed to get update Account Profile")
    );
  }
}
function* createAccountDetails({ payload }) {
  try {
    const response = yield requestCreateAccountDetails(payload);
    yield put(CreateAccountDetailsSuccess(response.data));
  } catch (error) {
    yield put(
      CreateAccountDetailsFaliure("Failed to get Create Account Details")
    );
  }
}
function* editAccountProfile({ payload }) {
  try {
    const response = yield requestEditUpdateAccountProfile(payload);
    yield put(editUpdateAccountProfileSuccess(response.data));
  } catch (error) {
    yield put(
      editUpdateAccountProfileFaliure("Failed to get update Account profile")
    );
  }
}

function* updateSDWaiveOff({ payload }) {
  try {
    const response = yield requestUpdateSDWaiveOff(payload);
    yield put(updateSDWaiveOffSuccess(response.data));
  } catch (error) {
    yield put(updateSDWaiveOffFaliure("Failed to update SD Waive off Account"));
  }
}

function* updateSDDue({ payload }) {
  try {
    const response = yield requestUpdateSDDue(payload);
    yield put(updateSDDueSuccess(response.data));
  } catch (error) {
    yield put(updateSDDueFaliure("Failed to update SD Waive off Account"));
  }
}

function* fetchClientAccountIdAgreementList({ payload }) {
  try {
    const response = yield requestclientAccountIdAgreementList(payload);
    yield put(fetchClientAccountIdAgreementListSuccess(response));
  } catch (error) {
    yield put(fetchClientAccountIdAgreementListFaliure("Failed to get list of Agreements"));
  }
}

function* fetchClientAccountProposalList({ payload }) {
  try {
    const response = yield requestCreateProposalAccountList(payload);
    yield put(fetchClientAccountProposalListSuccess(response));
  } catch (error) {
    yield put(fetchClientAccountProposalListFailure("Failed to get list of Proposals"));
  }
}

function* fetchClientByIdGenerateProposal({ payload }) {
  try {
    const response = yield requestGetByIdProposalGenerate(payload);
    yield put(fetchProposalClientByIdSuccess(response));
  } catch (error) {
    yield put(fetchProposalClientByIdFailure("Failed to get list of generate Proposals"));
  }
}

function* fetchClientByIdOtViewProposal({ payload }) {
  try {
    const response = yield requestGetByIdProposalOtView(payload);
    yield put(fetchProposalClientByIdOtViewSuccess(response));
  } catch (error) {
    yield put(fetchProposalClientByIdOtViewFailure("Failed to get list of Proposals"));
  }
}


function* createProposalAccount({ payload }) {
  try {
    //service add
    const response = yield requestCreateProposalProfile(payload);
    yield put(createProposalAccountSuccess(response.data));
  } catch (error) {
    yield put(createProposalAccountFailure("Failed to create Proposal Account"));
  }
}

function* fetchAccountAgreementData({ payload }) {
  try {
    const response = yield fetchAgreementDataForAccount(payload);
    yield put(fetchAgreementDataForAccountSuccess(response));
  } catch (error) {
    yield put(fetchAgreementDataForAccountFailure("Failed to fetch agreement data"));
  }
}

function* fetchAccountBookingData({ payload }) {
  try {
    const response = yield requestAccountBookingList(payload);
    yield put(fetchAccountBookingListSuccess(response));
  } catch (error) {
    yield put(fetchAccountBookingListFailure("Failed to fetch booking data"));
  }
}
function* fetchBookingByAccountData({ payload }) {
  try {
    const response = yield requestBookingByAccountList(payload);
    yield put(fetchBookingByAccountListSuccess(response));
  } catch (error) {
    yield put(fetchBookingByAccountListFaliure("Failed to fetch booking data"));
  }
}
function* syncFailedMemberData({ payload }) {
  try {
    const response = yield requestSyncFailedMember(payload);
    yield put(syncFailedMemberSuccess(response));
  } catch (error) {
    yield put(syncFailedMemberFaliure("Failed to fetch booking data"));
  }
}